"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgBluetooth = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M25 26.414v6.172l3.086-3.086L25 26.414zm3.086-7.914L25 15.414v6.172l3.086-3.086zm-5.5 5.5l-4.793-4.793a1 1 0 011.414-1.414L23 21.586V13c0-.89 1.077-1.337 1.707-.707l5.5 5.5a1 1 0 010 1.414L25.414 24l4.793 4.793a1 1 0 010 1.414l-5.5 5.5c-.63.63-1.707.184-1.707-.707v-8.586l-3.793 3.793a1 1 0 01-1.414-1.414L22.586 24z",
    id: "bluetooth_svg__a"
  }));
};

var _default = SvgBluetooth;
exports.default = _default;